import React from 'react';
import {Col, Container, Row} from 'react-bootstrap';
import {Link} from 'gatsby';

function Cutttingedge(props) {
    return (
        <div className="p-100 tekrevol_dark_bg lp_discuss lp_ready_project hv-100" style={{ backgroundColor: "#F47A1F" }}>
            <Container className="h-100">
                <Row className="h-100">
                    <Col xs={12} md={12} lg={12} xl={8} xxl={8} className="m-auto text-center">
                            <h2>Ready to Discuss Your Project?</h2>
                        <p>We're excited to help you achieve your goals and transform them into a top-notch digital solution. Claim your free consultation now!</p>
                        <Link to="tel:+8003629239"
                              className="border_btn" aria-label="TekRevol Contact">Book A Quick Call!</Link>
                         <p>Or, drop your details in the form below to share your requirements.</p>      
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default Cutttingedge;